import React, { Fragment, useState, useEffect, useContext } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import { useQuery } from "@apollo/react-hooks";
import { userQueries } from "./user/resolvers";
import { rolesQueries } from "./resolvers";
import { Loading } from "./components";
import _ from "lodash";
import alertify from "alertifyjs";
import { RoleContext } from "../src/contexts";
import { Header, PageContainer } from "./components";
import { Home, Companies, Persons } from "./pages";
import { Confirm } from "../src/custom";

const InitialState = {
  currentcompany: "",
  Roles: "",
  activeUser: "",
  Pages: "",
  Companies: "",
};

const App = () => {
  const { state } = useContext(RoleContext);
  const [companychanged, setCompanychanged] = useState(false);
  const [initialState, setInitialState] = useState(InitialState);
  const [activeUser, setActiveUser] = useState();

  const resetState = () => {
    setInitialState(InitialState);
  };

  const handleChangeCurrentCompany = async (currentcompany) => {
    await localStorage.setItem(
      "currentcompany",
      JSON.stringify(currentcompany)
    );
    window.location.reload();
    //await setCompanychanged(true);
  };

  const { data: Roles, loading: loadingroles } = useQuery(
    rolesQueries.ROLES_MY,
    {
      onCompleted({ Roles }) {
        //console.log(Roles);
        if (Roles.length === 0) {
          alertify.error(
            "Kullanıcı Yetkisi Bulunamadı. Lütfen Sistem Yöneticiniz ile Görüşün.!!!",
            5
          );
          clientActiveUser.writeData({
            data: {
              isLoggedIn: false,
            },
          });
          resetState();
          localStorage.clear();
        }
      },
    }
  );

  const {
    loading: loadingactiveuser,
    client: clientActiveUser,
    refetch,
  } = useQuery(userQueries.ACTIVE_USER, {
    onCompleted({ activeUser }) {
      if (!activeUser) {
        clientActiveUser.writeData({
          data: {
            isLoggedIn: false,
          },
        });
        resetState();
        localStorage.clear();
      } else {
        setActiveUser(activeUser);
      }
    },
  });

  const createRoles = (Roles) => {
    const currentcompany = localStorage.getItem("currentcompany");
    const company = currentcompany
      ? JSON.parse(currentcompany)
      : initialState.currentcompany
      ? initialState.currentcompany
      : Roles[0].company;

    let pages = {
      pageList: [],
      homepage: "",
    };

    let PageList = [];
    const role = [
      { name: "Üst Gözetmen", value: "supervisor", homepage: "home" },
      { name: "Gözetmen", value: "visor", homepage: "home" },
      { name: "Yönetici", value: "manager", homepage: "home" },
      { name: "Kullanıcı", value: "user", homepage: "home" },
    ];

    if (Roles)
      for (let x of Roles) {
        if (company.id === x.company.id) {
          role.map((y) => {
            if ([y.name].includes(x.type)) {
              PageList = state[y.value];
              pages.homepage = y.homepage;
            }
          });
        }
      }
    pages.pageList = [...PageList];
    pages.pageList = _.uniqBy(pages.pageList, function (e) {
      return e.name;
    });

    localStorage.setItem("currentcompany", JSON.stringify(company));

    let Companies = Roles.map((x) => {
      return x.company;
    });

    Companies = _.uniqBy(Companies, function (e) {
      return e.id;
    });

    setInitialState({
      ...initialState,
      Roles,
      Pages: pages,
      currentcompany: company,
      activeUser: activeUser,
      Companies,
    });
    setCompanychanged(false);
  };

  useEffect(() => {
    if (Roles && !activeUser) {
      refetch();
    }
    if (Roles && activeUser) {
      if (Roles.Roles) if (Roles.Roles.length > 0) createRoles(Roles.Roles);
    }
  }, [Roles, activeUser, companychanged]);

  if (loadingactiveuser || loadingroles || !initialState.currentcompany)
    return <Loading />;

  const props = {
    ...initialState,
    resetState,
    handleChangeCurrentCompany,
  };

  return (
    <Fragment>
      <PageContainer>
        <Router>
          <Header {...props} />
          <Switch>
            <Route
              path="/confirm"
              exact
              render={() => <Confirm {...props} />}
            />
            <Route
              path="/companies"
              exact
              render={() => <Companies {...props} />}
            />
            <Route
              path="/persons"
              exact
              render={() => <Persons {...props} />}
            />
          </Switch>
        </Router>
      </PageContainer>
    </Fragment>
  );
};

export default App;
